import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { getSourceColour } from "../table/utils";
import { normaliseCaps } from "./utils";
function SourceTag(props) {
    const { source, className } = props;
    const sourceColour = getSourceColour(source);
    return (_jsx("div", { className: `tol-customise-config-source-no-float ${className}`, 
        // @ts-ignore
        style: { "--config-source-bg-color": sourceColour }, children: normaliseCaps(source) }));
}
export default SourceTag;
